export function sumCost(sum: number, step: { cost: number} ): number {
  return sum + step.cost
}
